"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_components_1 = require("@securityproducts/core-components");
var toggleSeries_1 = require("@securityproducts/core-components/lib/util/data/toggleSeries");
var emotion_1 = require("emotion");
var React = __importStar(require("react"));
var callStatistics_i18n_1 = require("./callStatistics.i18n");
var toggle_1 = require("../../../util/toggle/toggle");
var styles = {
    totalCalls: {
        shape: "circle",
        fill: "#dfe1e3",
        stroke: "#dfe1e3",
    },
    immediatelyConnected: {
        shape: "circle",
        fill: "#66af3d",
        stroke: "#66af3d",
    },
    routedAway: {
        shape: "circle",
        fill: "#e2e044",
        stroke: "#e2e044",
    },
    abandoned: {
        shape: "circle",
        fill: "#acdef8",
        stroke: "#acdef8",
    },
    connectedAfterQueueing: {
        shape: "circle",
        fill: "#9ed350",
        stroke: "#9ed350",
    },
    timedOut: {
        stroke: "#f0a029",
        fill: "#f0a029",
        shape: "circle",
    },
    failedDueToMaxCallers: {
        shape: "circle",
        fill: "#09a3e7",
        stroke: "#09a3e7",
    },
    other: {
        shape: "circle",
        fill: "#0085c7",
        stroke: "#0085c7",
    },
};
var allMetrics = [
    "totalCalls",
    "immediatelyConnected",
    "connectedAfterQueueing",
    "routedAway",
    "timedOut",
    "abandoned",
    "failedDueToMaxCallers",
    "other",
];
Object.freeze(allMetrics);
function CallStatistics(props) {
    var strings = core_components_1.useLocalisation(callStatistics_i18n_1.callStatisticsTranslations, props.language);
    var apexMetricName = {
        immediatelyConnected: strings.immediatelyConnected.split(" ").join("x"),
        connectedAfterQueueing: strings.connectedAfterQueueing.split(" ").join("x"),
        routedAway: strings.routedAway.split(" ").join("x"),
        timedOut: strings.timedOut.split(" ").join("x"),
        abandoned: strings.abandoned.split(" ").join("x"),
        failedDueToMaxCallers: strings.failedDueToMaxCallers.split(" ").join("x"),
        totalCalls: strings.totalCalls.split(" ").join("x"),
        other: strings.other.split(" ").join("x"),
    };
    var _a = React.useState(__spreadArrays(allMetrics)), enabledMetrics = _a[0], setEnabledMetrics = _a[1];
    var metrics = React.useState(props.forceSelection ? props.forceSelection : __spreadArrays(allMetrics))[0];
    function toggleMetric(metric) {
        toggleSeries_1.toggleSeries("call-statisticschart", apexMetricName[metric]);
        if (enabledMetrics.indexOf(metric) > -1) {
            enabledMetrics.splice(enabledMetrics.indexOf(metric), 1);
            setEnabledMetrics(enabledMetrics);
        }
        else {
            enabledMetrics.push(metric);
            setEnabledMetrics(enabledMetrics);
        }
    }
    var lineStyles = getLineStyles(metrics);
    var data = metrics.map(function (metric) { return ({
        name: getName(metric, strings),
        data: props[metric],
        type: (metric === "totalCalls" ? "column" : "line"),
    }); });
    return (React.createElement(core_components_1.LineChart, { id: "call-statistics", heading: strings.callStatistics, metric: "count", displayRange: props.display, data: data, lineStyles: lineStyles, showLegend: false, yAxisTitle: strings.calls, language: props.language, timezone: props.timezone },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: totalCallsToggle },
                React.createElement(toggle_1.Toggle, { id: "totalCalls", text: strings.totalCalls, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                        shape: "circle",
                        fill: "#dfe1e3",
                        stroke: "#dfe1e3",
                        size: 11,
                    }), checked: metrics.indexOf("totalCalls") > -1 })),
            React.createElement("div", { className: toggleContainer, id: "call-statisics-toggles" },
                React.createElement("div", { style: { width: 300 } },
                    React.createElement(toggle_1.Toggle, { id: "immediatelyConnected", text: strings.immediatelyConnected, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#66af3d",
                            stroke: "#66af3d",
                            size: 10,
                        }), checked: metrics.indexOf("immediatelyConnected") > -1 }),
                    React.createElement(toggle_1.Toggle, { id: "connectedAfterQueueing", text: strings.connectedAfterQueueing, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#9ed350",
                            stroke: "#9ed350",
                            size: 10,
                        }), checked: metrics.indexOf("connectedAfterQueueing") > -1 }),
                    React.createElement(toggle_1.Toggle, { id: "routedAway", text: strings.routedAway, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#e2e044",
                            stroke: "#e2e044",
                            size: 11,
                        }), checked: metrics.indexOf("routedAway") > -1 }),
                    React.createElement(toggle_1.Toggle, { id: "timedOut", text: strings.timedOut, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#f0a029",
                            stroke: "#f0a029",
                            size: 11,
                        }), checked: metrics.indexOf("timedOut") > -1 })),
                React.createElement("div", null,
                    React.createElement(toggle_1.Toggle, { id: "abandoned", text: strings.abandoned, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#acdef8",
                            stroke: "#acdef8",
                            size: 11,
                        }), checked: metrics.indexOf("abandoned") > -1 }),
                    React.createElement(toggle_1.Toggle, { id: "failedDueToMaxCallers", text: strings.failedDueToMaxCallers, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#09a3e7",
                            stroke: "#09a3e7",
                            size: 10,
                        }), checked: metrics.indexOf("failedDueToMaxCallers") > -1 }),
                    React.createElement(toggle_1.Toggle, { id: "other", text: strings.other, toggleMetric: toggleMetric, keyIcon: core_components_1.createIcon({
                            shape: "circle",
                            fill: "#0085c7",
                            stroke: "#0085c7",
                            size: 10,
                        }), checked: metrics.indexOf("other") > -1 }))))));
}
exports.CallStatistics = CallStatistics;
CallStatistics.defaultProps = {
    totalCalls: [],
    immediatelyConnected: [],
    connectedAfterQueueing: [],
    routedAway: [],
    timedOut: [],
    abandoned: [],
    failedDueToMaxCallers: [],
    other: [],
};
var totalCallsToggle = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 20px;\n    right: 35px;\n"], ["\n    position: absolute;\n    top: 20px;\n    right: 35px;\n"])));
var toggleContainer = emotion_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n\n    @media print {\n        display: flex;\n        flex-wrap: wrap;\n    }\n"], ["\n    display: flex;\n\n    @media print {\n        display: flex;\n        flex-wrap: wrap;\n    }\n"])));
function getLineStyles(data) {
    return data.map(function (datum) { return styles[datum]; });
}
function getName(raw, strings) {
    return strings[raw];
}
var templateObject_1, templateObject_2;
